<script>
  import CardAlmanac from '/Widgets/CardAlmanac'
  import CardProjectEvent from '/Widgets/CardProjectEvent'
  import CardRelatedEvent from '/Widgets/CardRelatedEvent'
  import CardRelatedArtwork from '/Widgets/CardRelatedArtwork'
  import { _ } from 'svelte-i18n'

  export let related, almanac=false

  console.log("Related Widgets data", related)

  // filter by section
  const artworks    = related.filter( e => "artwork_Entry".indexOf(e.__typename) > -1)
  const media       = related.filter( e => ["audio_Entry", "video_Entry"].indexOf(e.__typename) > -1)
  const text        = related.filter( e => ["text_Entry"].indexOf(e.__typename) > -1)
  const projects    = related.filter( e => ["project_Entry"].indexOf(e.__typename) > -1)
  const events      = related.filter( e => ["event_Entry"].indexOf(e.__typename) > -1)
  const collections = related.filter( e => ["collection_Entry"].indexOf(e.__typename) > -1)

  // aggregate for widgets
  const almanacContent = [...media, ...text, ...collections]

</script>

{#if artworks.length > 0 }
  <h6 class="header" class:almanac>
    {$_("related.related_artworks")}
  </h6>
  {#each artworks as artwork}
    <div class="artwork card">
      <CardRelatedArtwork {artwork} />
    </div>
  {/each}  
{/if}

{#if almanacContent.length > 0}
  <h6 class="header almanacWidget" class:almanac>
    {#if almanac}
      {$_("related.related_content")}
    {:else}
      {$_("related.from_the_almanac")}
    {/if}
  </h6>
  <CardAlmanac flow entries={almanacContent} noheader />
{/if}

{#if projects.length > 0}
  <h6 class="header" class:almanac>
    {$_("related.related_programme")}
  </h6>
  {#each projects as program}
    <div class="project card">
      <CardProjectEvent event={program} large />
    </div>
  {/each}  
{/if}

{#if events.length > 0}
  <h6 class="header" class:almanac>
    {$_("related.related_events")}
  </h6>
  {#each events as event}
    <div class="project card">
      <CardRelatedEvent event={event} />
    </div>
  {/each}  
{/if}

<style lang="scss">
  .header {
    @include typo-grotesk-title-captions-20;
    margin-top: 34px; // 
    margin-bottom: 15px;
    color: $color-white;
    text-align: left;

    &.almanac {
      color: black;
    }
    &:not(.almanac) {
      text-shadow: $shadow;
    }
    &.almanacWidget {
      @include typo-serif-small-caps-28;
    }

    @include media-small {
      padding-left: 12px;
    }

    @include media-large-only {
      padding-left: 30px;
    }

    @include media-larger {
      padding-left: 40px;
    }
  }

  .card + .card {
    margin-top: 1em;
  }
</style>
